// extracted by mini-css-extract-plugin
export default {"rating":"tE-z","numberOfStars":"uE-z","count":"vE-z","barGraphSpacing":"wE-z","barGraph":"xE-z"};